const SwitzerlandFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="20" fill="#FF0000"/>
    <rect x="13" y="6" width="4" height="8" fill="#FFFFFF"/>
    <rect x="11" y="8" width="8" height="4" fill="#FFFFFF"/>
  </svg>
);

export default SwitzerlandFlag;